module.exports = __webpack_public_path__ + "img/Hero@3x.e284937c.png";